module.exports = __webpack_public_path__ + "static/media/twitter.c4c914f8.svg";